export default __webpack_public_path__ + "images/6bb838622117b6460728d537c5ae42f3-san_jose_desktop.webp";